// src/common/MonthPicker.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Button, Grid, Popover } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { AppStyle } from '../value/AppConst';

const MainBox = styled(Box)({position:'relative', paddingTop:8,  display:'inline-block'});
const PickerLabel = styled('div')({
    fontSize:'0.7rem', color:AppStyle.PrimaryRGB, padding:'0px 5px 0px 5px',
    position:'absolute', top:0, left:10, borderRadius:7,
});

// In popover
const MonthWidth = 60;
const CallendarBox = styled(Box)({
    maxWidth: MonthWidth * 4 + 20, maxHeight: '50vh',
    overflowY: 'auto', overflowX: 'hidden',
});

const YearLabelBox = styled(Box)({
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 5, border: AppStyle.BorderCCC, borderRadius: 5, margin:2,
    backgroundColor: '#f3f3f3',
});
const MonthListBox = styled(Box)({
    display: 'flex', flexWrap: 'wrap',
});

function getDateWithMonthOffset(offset) {
    const date = new Date();
    date.setMonth(date.getMonth() + offset);
    return date;
}

function getMonthList(minDate, maxDate) {
    const monthList = [];
    let date = new Date(minDate);
    while(date <= maxDate) {
        monthList.push(date);
        date = new Date(date.setMonth(date.getMonth() + 1));
    }
    return monthList;
}

// return [{year:2021, months:['01','02',..]}]
function getYearMonthPack(minDate, maxDate) {
    const monthList = getMonthList(minDate, maxDate);
    const map = {};
    monthList.forEach(date=>{
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        if(!map[year]) map[year] = [];
        map[year].push(month);
    });
    const yearMonthPack = [];
    for(const year in map) {
        yearMonthPack.push({year, months:map[year]});
    }
    return yearMonthPack;
}

export default function MonthPicker({
    dict,
    value, // YYYY-MM-01
    monthsAgo, // default: 12
    upToAfter, // default: 12
    disabled,
    onChange,
    error,
}) {
    const [selected, setSelected] = useState({year:null, month:null});
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(()=>{
        if(value) {
            const [year, month] = value.split('-');
            setSelected({year: parseInt(year), month: parseInt(month)});
        }
    }, [value]);

    const thisYear = new Date().getFullYear();
    const minMonth = monthsAgo || 12;
    const maxMonth = upToAfter || 12;
    const minDate = getDateWithMonthOffset(-minMonth);
    const maxDate = getDateWithMonthOffset(maxMonth); 

    const yearAndMonths = getYearMonthPack(minDate, maxDate);

    const onClickMonth = (year, month) => {
        setAnchorEl(null);
        const ymd = `${year}-${month < 10 ? '0'+month : month}-01`;
        onChange(dict.id, ymd, false); // false for error
    };

    const buttonStyle = {
        fontWeight: 'normal',
        minWidth:150,
        backgroundColor:'white',
        borderBottom:AppStyle.BorderCCC
    };
    if(error) buttonStyle.border = '1px solid red';

    return (
        <MainBox>
            <Button
                variant={AppStyle.mui.text}
                style={buttonStyle}
                endIcon={<CalendarMonthIcon/>}
                color={AppStyle.mui.inherit}
                onClick={(e)=>setAnchorEl(e.currentTarget)}
                disabled={disabled}
            >
                {
                    selected.year && selected.month
                    ?
                        `${selected.year}년 ${selected.month}월`
                    :
                        '....년 ..월'
                }
            </Button>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={()=>setAnchorEl(null)}
                anchorOrigin={{vertical:'bottom', horizontal:'center'}}
                transformOrigin={{vertical:'top', horizontal:'center'}}
            >
                <CallendarBox>
                {
                    yearAndMonths
                    .sort((a,b)=>b.year-a.year)
                    .map(yearPack => {
                        return(
                            <React.Fragment key={yearPack.year}>
                                <YearLabelBox style={{color:`${thisYear}`===yearPack.year ? 'blue' : 'inherit'}}>
                                    {yearPack.year}년
                                </YearLabelBox>
                                <MonthListBox>
                                    <Grid container spacing={1}>
                                        {
                                            yearPack.months.map(month=>{
                                                return(
                                                    <Grid item xs={3} key={month}>
                                                        {
                                                            `${yearPack.year}-${month}`===`${selected.year}-${selected.month}`
                                                            ?
                                                            <Button
                                                                variant={AppStyle.mui.contained}
                                                                fullWidth
                                                            >
                                                                {month}월
                                                            </Button>
                                                            :
                                                            <Button
                                                                variant={AppStyle.mui.text}
                                                                fullWidth
                                                                onClick={()=>onClickMonth(yearPack.year, month)}
                                                            >
                                                                {month}월
                                                            </Button>
                                                        }
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                </MonthListBox>
                            </React.Fragment>
                        )
                    })
                }
                </CallendarBox>
            </Popover>
            <PickerLabel>{dict.label || '월 선택'}</PickerLabel>
        </MainBox>
    );
}
